import { render, staticRenderFns } from "./addSliderPop.vue?vue&type=template&id=56d630ec&scoped=true"
import script from "./addSliderPop.vue?vue&type=script&lang=js"
export * from "./addSliderPop.vue?vue&type=script&lang=js"
import style0 from "./addSliderPop.vue?vue&type=style&index=0&id=56d630ec&prod&lang=stylus&scoped=true"
import style1 from "./addSliderPop.vue?vue&type=style&index=1&id=56d630ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d630ec",
  null
  
)

export default component.exports